import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

/**
 * Opens a URL outside the WebView: system browser on Capacitor iOS/Android,
 * new tab on web.
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (Capacitor.getPlatform() !== 'web') {
    await Browser.open({ url });
    return;
  }

  const win = window.open(url, '_blank', 'noopener,noreferrer');
  if (win) {
    win.opener = null;
  }
}
